import React, { useState } from "react";
import { TabButtons } from "../detail";
import { DetailsCardMenu } from "../data";
import "../index.css";
import "./index.css";
import { DummyCard } from "../trading/index";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import TradingViewChart from "../../../components/TradingViewChart";
import BottomDrawer from "./drawer";
import { Overview } from "./components/overview";
import { AlternatingRows } from "./components/alternating-rows";

export const data = [
  { label: "Last Trade Vol", value: "3.000" },
  { label: "Last Three Trade", value: "16, 41.48" },
  { label: "Total Volume", value: "11,631.669" },
  { label: "Total Traders", value: "672" },
  { label: "Upper Cap", value: "2.25" },
  { label: "Lower Lock", value: "0.25" },
];

export const statistics = [
  { label: "Net Profit", value: "-1500" },
  { label: "Revenue", value: "3200" },
  { label: "Expenses", value: "-800" },
  { label: "Growth", value: "120" },
];

const sampleRows = [
  ["--", "--", "--", "--", "--", "--"],
  ["--", "--", "--", "--", "--", "--"],
];

const footerRow = ["", "T. Vol", "Avg Bid", "Avg Ask", "T. Vol", ""];

const columns = ["Flag", "Shares", "Bid", "Ask", "Shares", "Flag"];

const columns1 = ["Orders", "Shares", "Bid", "Ask", "Shares", "Orders"];

const aboutData = [
  { label: "Company Secretary", value: "Kamran Hafeez" },
  { label: "Ceo", value: "Zafar Mdhmood" },
  { label: "Symbol", value: "BOP" },
  { label: "Websites", value: "www.bcop.com.pk" },
  {
    label: "Address",
    value: "N, A-489 9th Street North, Block, Nazimabad, Karachi, 74700",
  },
  {
    label: "Registrar",
    value: "N, A-489 9th Street North, Block, Nazimabad, Karachi, 74700",
  },
  {
    label: "Auditor",
    value: "N, A-489 9th Street North, Block, Nazimabad, Karachi, 74700",
  },
];





export const MarketTable = ({ title, columns, rows, footer }) => {
  return (
    <div className="mar-table-wrapper">
      {title && <h2 className="mar-table-title">{title}</h2>}

      <table className={"mar-table"}>
        {columns && (
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th
                  key={i}
                  className={`mar-heading ${
                    col.toLowerCase() === "bid"
                      ? "mar-green"
                      : col.toLowerCase() === "ask"
                      ? "mar-red"
                      : ""
                  }`}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
        )}

        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} className="mar-cell">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
          {footer && (
            <tr className="mar-footer-row">
              {footer.map((cell, i) => (
                <td key={i} className="mar-footer-cell">
                  {cell}
                </td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const TableWithDropdown = ({ data = [], onDropdownChange }) => {
  const [mode, setMode] = useState("quarterly");

  const generateQuarterlyOptions = () => {
    const options = [];
    const current = new Date();
    let year = current.getFullYear();
    let quarter = Math.floor((current.getMonth() + 3) / 3);

    while (year >= 2023) {
      while (quarter >= 1) {
        options.push(`${String(quarter).padStart(2, "0")}/${year}`);
        quarter--;
      }
      year--;
      quarter = 4;
    }

    return options;
  };

  const generateAnnualOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from(
      { length: currentYear - 2009 },
      (_, i) => `${currentYear - i}`
    );
  };

  const dropdownOptions =
    mode === "quarterly" ? generateQuarterlyOptions() : generateAnnualOptions();

  return (
    <div className="fundamental-wrapper">
      <div className="fundamental-toggle">
        <label>
          <input
            type="radio"
            name="mode"
            value="quarterly"
            checked={mode === "quarterly"}
            onChange={() => setMode("quarterly")}
          />
          Quarterly
        </label>
        <label>
          <input
            type="radio"
            name="mode"
            value="annual"
            checked={mode === "annual"}
            onChange={() => setMode("annual")}
          />
          Annually
        </label>
      </div>

      <select
        className="fundamental-dropdown"
        onChange={(e) => onDropdownChange?.(e.target.value)}
      >
        {dropdownOptions.map((option, i) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </select>

      <div className="alternating-rows1">
        {data.map((item, index) => (
          <div
            key={index}
            className={`row-item ${index % 2 === 0 ? "row-light" : "row-dark"}`}
          >
            <span className="label">{item.label}</span>
            <span className="value">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};



const MarketDepth = () => {
  return (
    <>
      <MarketTable
        rows={sampleRows}
        footer={footerRow}
        columns={columns}
        title={"MBO-Market Depth By Order"}
      />
      <MarketTable
        rows={sampleRows}
        footer={footerRow}
        columns={columns1}
        title={"MBP-Market Depth By Price"}
      />
    </>
  );
};

const About = () => {
  return (
    <div className="alternating-rows-wrapper">
      <div className="about-header">
        <div className="heading-row">
          <span>Description</span>
        </div>
        <p className="about-header-p">
          Here at Innova8ors, we are devoted to providing ERP Solutions, UI/UX
          Branding, Mobile App Development, and Digital Marketing which is
          reflected in the long-term business relationships with our clients and
          employees. Our professional team is expert in ensuring customer
          satisfaction while providing high-quality IT services. Explore the
          world of innovation and learn how we serve globally through our
          business map.
        </p>
      </div>

      <div className="alternating-rows">
        {aboutData.map((item, index) => (
          <div
            key={index}
            className={`row-item ${index % 2 === 0 ? "row-light" : "row-dark"}`}
          >
            <span className="label">{item.label}</span>
            <span className="value">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const Fundamental = ({ data = [], dropdownOptions = [], onDropdownChange }) => {
  return (
    <div className="fundamental-wrapper">
      <select className="fundamental-dropdown" onChange={onDropdownChange}>
        {dropdownOptions.map((option, i) => (
          <option key={i} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <div className="fundamental-rows">
        {data.map((item, index) =>
          item.type === "separator" ? (
            <div key={`sep-${index}`} className="fundamental-separator" />
          ) : (
            <div
              key={index}
              className={`fundamental-row-item ${
                index % 2 === 0
                  ? "fundamental-row-light"
                  : "fundamental-row-dark"
              }`}
            >
              <span className="fundamental-label">{item.label}</span>
              <span className="fundamental-value">{item.value}</span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const Technical = () => {
  return (
    <>
      <AlternatingRows data={data} heading={"Hello world"} />
      <AlternatingRows data={data} heading={"Hello world"} />
    </>
  );
};

export const TradingDetails = () => {
  const [selectedTab, setSelectedTab] = useState("");
  return (
    <div className="margin-bottom-trading">
      <TabButtons
        tabs={DetailsCardMenu}
        defaultTab={`${DetailsCardMenu[0]}`}
        onTabChange={(tab) => setSelectedTab(tab)}
      />
      <BottomDrawer />
      {selectedTab == "Overview" && <Overview />}
      {selectedTab == "Market Depth" && <MarketDepth />}
      {selectedTab == "About" && <About />}
      {selectedTab == "Fundamental" && (
        <Fundamental
          data={[
            { label: "Company Secretary", value: "Kamran Hafeez" },
            { label: "Ceo", value: "16, 41.48" },
            { type: "separator" },
            { label: "Symbol", value: "11,631.669" },
            { label: "Websites", value: "672" },
            { type: "separator" },
            { label: "Address", value: "2.25" },
            { label: "Registrar", value: "0.25" },
          ]}
          dropdownOptions={[
            { label: "Option 1", value: "1" },
            { label: "Option 2", value: "2" },
          ]}
          onDropdownChange={(e) => console.log("Selected:", e.target.value)}
        />
      )}
      {selectedTab == "Technical" && <Technical />}
      {selectedTab == "Income Statement" && (
        <TableWithDropdown
          data={[
            { label: "Company Secretary", value: "Kamran Hafeez" },
            { label: "Ceo", value: "16, 41.48" },
            { label: "Symbol", value: "11,631.669" },
            { label: "Websites", value: "672" },
            { label: "Address", value: "2.25" },
            { label: "Registrar", value: "0.25" },
          ]}
        />
      )}

      {selectedTab == "Balance Sheet" && (
        <TableWithDropdown
          data={[
            { label: "Company Secretary", value: "Kamran Hafeez" },
            { label: "Ceo", value: "16, 41.48" },
            { label: "Symbol", value: "11,631.669" },
            { label: "Websites", value: "672" },
            { label: "Address", value: "2.25" },
            { label: "Registrar", value: "0.25" },
          ]}
        />
      )}
    </div>
  );
};
